@if (regimenClasses().length) {
  <div class="tw-bg-white tw-py-4 tw-flex tw-flex-col">
    @if (isCarousel()) {
      <swiper class="tw-max-w-full tw-min-w-0" [config]="swiperConfig">
        @for (regimenClass of regimenClasses(); track regimenClass) {
          <div *swiperSlide class="tw-w-ai-analysis-slide tw-shrink-0">
            <rebranded-complete-your-profile-card
              [regimenClass]="regimenClass"
              [gender]="gender()">
            </rebranded-complete-your-profile-card>
          </div>
        }
      </swiper>
    } @else {
      <div class="tw-px-4">
        <rebranded-complete-your-profile-card
          [regimenClass]="regimenClasses()[0]"
          [gender]="gender()">
        </rebranded-complete-your-profile-card>
      </div>
    }
    <p id="rcyp-privacy-note"
       class="tw-text-100 tw-text-gray-500 tw-opacity-80 tw-m-0 tw-text-center tw-lowercase"
       [class]="isCarousel() ? 'tw-mt-2' : 'tw-mt-1'"
       i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</p>
  </div>
}
